export default __webpack_public_path__ + "static/media/afl2.534e8f0d.svg";